import { Skeleton } from '@/components/ui/skeleton'

export const ServiceVettingMerchFormSkeleton = () => {
	return (
		<div className='h-full flex-1 py-10'>
			<div className='flex w-full flex-col gap-10'>
				<div className='flex w-full flex-col gap-4'>
					<Skeleton height={30} width={80} />
					<Skeleton height={20} width={100} />
					<Skeleton height={42} />
				</div>

				{[1, 2, 3].map((n) => (
					<div className='flex w-full flex-col gap-4' key={n}>
						<Skeleton height={20} width={100} />
						<Skeleton height={100} />
					</div>
				))}

				<div className='flex w-full flex-col gap-4'>
					<Skeleton height={30} width={100} />
					<Skeleton height={20} width={100} />
					<Skeleton height={42} />
				</div>

				{[1, 2].map((n) => (
					<div className='flex w-full flex-col gap-4' key={n}>
						<Skeleton height={20} width={100} />
						<Skeleton height={100} />
					</div>
				))}
			</div>
		</div>
	)
}

ServiceVettingMerchFormSkeleton.displayName = 'ServiceVettingMerchFormSkeleton'
